module.exports = __webpack_public_path__ + "components/weather-icon/static/daycloud-97fcdf4af5e8592f0edcc037b1fa214e.svg";